<!--FDC产品购买-->
<template>
  <div class="xz_buyDialog">
    <el-dialog :before-close="cancel"
      :title="isAdd == 'triall' ? '客户试用' : isAdd == 'buy' ? '增购模块' : '购买产品'"
      :visible.sync="visible" :close-on-click-modal="false" width="700px" :loading="dialog_loading">
      <el-form v-if="!payTableShow" :model="form" ref="form" :rules="formRules">
        <el-form-item :label-width="formLabelWidth" :label="isAdd == 'buy' ? '企业名称' : '授权企业名称'" prop="name">
          <el-input v-model="form.name" :disabled="isAdd == 'buy'"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" :label="isAdd == 'buy' ? '企业授权码' : '授权码'" prop="code">
          <el-input v-model="form.code" :disabled="isAdd == 'buy'"></el-input>
        </el-form-item>
        <el-form-item v-if="isAdd != 'buy'" :label-width="formLabelWidth" label="授权码密钥" prop="key">
          <el-input v-model="form.key"></el-input>
        </el-form-item>
        <el-form-item v-if="isAdd != 'buy'" :label-width="formLabelWidth" label="联系人" prop="contact_name">
          <el-input v-model="form.contact_name"></el-input>
        </el-form-item>
        <el-form-item v-if="isAdd != 'buy'" :label-width="formLabelWidth" label="联系电话" prop="mobile">
          <el-input v-model="form.mobile"></el-input>
        </el-form-item>

        <el-form-item :label-width="formLabelWidth" label="选择模块" prop="modules">
          <div v-if="isAdd !== 'buy'" class="scene-quick-btn" @click="openSceneDialog">✦ 按场景快捷选择</div>
          <el-checkbox-group v-model="form.modules" class="module-checkbox-group">
            <el-checkbox v-for="item in modulesList" :key="item.code" :label="item.code" :disabled="purchasedModuleCodes.includes(item.code)">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item v-if="isAdd != 'buy'" :label-width="formLabelWidth" label="工作用户数" prop="bi_users">
          <el-input-number size="small" v-model="form.bi_users" :min="0" :step="1"></el-input-number>
        </el-form-item>
        <el-form-item v-if="isAdd != 'buy'" :label-width="formLabelWidth" label="查看用户数" prop="std_users">
          <el-input-number size="small" v-model="form.std_users" :min="0" :step="1"></el-input-number>
        </el-form-item>

        <div v-if="isAdd != 'triall' && isAdd != 'buy'">
          <el-form-item :label-width="formLabelWidth" label="购买方式" prop="buy_type">
            <el-radio-group v-model="form.buy_type" @change="buy_type_change">
              <el-radio :label="1">买断模式</el-radio>
              <el-radio :label="2">按年订阅</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <el-form-item v-if="form.buy_type == 2 && isAdd != 'triall' && isAdd != 'buy'" :label-width="formLabelWidth" label="购买时长">
          <el-input-number style="text-align: center;" size="small" v-model="form.new_months" :min="1" :max="100"
            :step="1"></el-input-number>
          <span style="margin-left: 10px;">年</span>
        </el-form-item>

        <el-form-item v-if="isAdd != 'buy'" :label-width="formLabelWidth" label="备注" prop="note">
          <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="form.note"> </el-input>
        </el-form-item>
      </el-form>
      <div v-if="payTableShow" class="clearfix">
        <el-table :data="payTableData" border style="width: 100%">
          <el-table-column prop="item" label="项目"></el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="days" label="时长">
            <template slot-scope="scope">
              <span>{{ scope.row.days }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="价格"></el-table-column>
        </el-table>
        <el-alert class="alert" style="margin-top: 10px;" title="支付描述" :type="payAlertType" :closable="false" :description="payDescription"></el-alert>
        <el-button v-if="payBtnShow" class="primary" style="margin-top: 10px; float: right;" @click="confirmPay">确认支付</el-button>
      </div>
      <div v-if="!payTableShow" slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button v-if="isAdd == 'triall'" class="primary" @click="triallClick">申请试用</el-button>
        <el-button v-else class="primary" @click="buyClick">预览价格</el-button>
      </div>
    </el-dialog>
    <sceneDialog ref="sceneDialog" :modulesList="modulesList" @apply="applyScene"></sceneDialog>
  </div>
</template>

<script>
import { trailFDCLocal, getFDCModulesList, fdcBuyPriceAuth, fdcBuyAuth, FDCLocalAddModulesPrice, FDCLocalAddModules, getFDCOrdersModules } from '@/api/afFdc';
import { payVerify } from '@/utils/pay';
import sceneDialog from './sceneDialog.vue';
export default {
  components: { sceneDialog },
  data() {
    var validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入联系电话'));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的11位手机号码'));
      } else {
        callback();
      }
    };
    return {
      dialog_loading: false,
      modifyId: null,
      isAdd: 'add',
      visible: false,
      formLabelWidth: '110px',
      form: {
        name: "",
        code: "",
        key: "",
        contact_name: "",
        mobile: "",
        pay_type: 1,
        note: "",
        modules: [],
        std_users: 0,
        bi_users: 0,
        buy_type: 1,
        new_months: 1,
      },
      formRules: {
        name: [
          { required: true, message: '请输入授权企业名称', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入企业授权码', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9]+$/, message: '授权码只支持数字和字母', trigger: 'blur' },
        ],
        key: [
          { required: true, message: '请输入授权码密钥', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9]+$/, message: '密钥只支持数字和字母', trigger: 'blur' },
        ],
        contact_name: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
        ],
        // mobile: [
        //   { required: true, validator: validatePhone, trigger: 'blur' },
        // ],
        modules: [
          { required: true, message: '请选择模块', trigger: 'change', type: 'array' },
        ],
      },
      modulesList: [],
      purchasedModuleCodes: [],
      workspaceModuleNames: ['AI小智', 'BI分析', '电子表格', '填报表单', '我的数据'],
      userInfo: null,
      // 价格预览
      payTableShow: false,
      payTableData: [],
      payDescription: "",
      payAlertType: "success",
      payBtnShow: false,
      payAction: null,
      payActionData: null,
      currentAuthRow: null,
    };
  },
  mounted() {
    this.getModulesList();
    this.getUserInfo();
  },
  methods: {
    getModulesList() {
      getFDCModulesList().then(res => {
        this.modulesList = res;
      }).catch(() => {});
    },

    getUserInfo() {
      this.userInfo = this.$store.getters.userInfo;
    },

    show(obj) {
      this.visible = true;
      this.payTableShow = false;
      this.currentAuthRow = obj || null;
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate();
      });
      if (this.isAdd == 'buy') {
        this.modifyId = obj.id;
        this.form.code = obj.code;
        this.form.name = obj.name;
        this.form.modules = [];
        this.form.std_users = 0;
        this.form.bi_users = 0;
        this.form.buy_type = 1;
        this.form.new_months = 1;
        this.purchasedModuleCodes = [];
        getFDCOrdersModules(obj.id).then(res => {
          this.purchasedModuleCodes = res.map(item => item.module_code);
          this.form.modules = [...this.purchasedModuleCodes];
        }).catch(() => {});
      } else if (this.isAdd == 'triall') {
        // 试用模式
      } else if (this.isAdd == 'add') {
        // 新购
      }
    },

    triallClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.validateUsers()) return;
          let obj = {
            name: this.form.name,
            code: this.form.code,
            key: this.form.key,
            contact_name: this.form.contact_name,
            mobile: this.form.mobile,
            note: this.form.note,
            modules: this.form.modules.join(','),
            fdc_std_users: this.form.std_users,
            fdc_bi_users: this.form.bi_users,
            trail_days: 30,
          };
          trailFDCLocal(obj)
            .then(() => {
              this.$message({ type: 'success', message: '申请试用成功' });
              this.resetForm();
              this.$parent.getAuthData();
              this.visible = false;
            })
            .catch(() => {});
        }
      });
    },

    resetForm() {
      this.form = {
        name: "",
        code: "",
        key: "",
        contact_name: "",
        mobile: "",
        pay_type: 1,
        note: "",
        modules: [],
        std_users: 0,
        bi_users: 0,
        buy_type: 1,
        new_months: 1,
      };
      this.purchasedModuleCodes = [];
    },

    buy_type_change() {},

    validateUsers() {
      if (this.isAdd === 'buy') return true;
      // 规1：工作空间功能关联校验
      const workspaceCodes = ['m_u_bi','m_u_form','m_ai','m_u_spreedsheet','m_u_data'];
      const hasWorkspaceModule = this.form.modules.some(code => workspaceCodes.includes(code));
      if (hasWorkspaceModule && this.form.bi_users === 0) {
        this.$message.error('您购买了工作空间相关功能，需购买至少1个工作用户才能使用。');
        return false;
      }
      // 规2：用户数全局校验
      if (this.form.bi_users === 0 && this.form.std_users === 0) {
        this.$message.error('请至少选择一类用户数（工作用户数与查看用户数不可同时为0）');
        return false;
      }
      return true;
    },

    buyClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.validateUsers()) return;

          if (this.isAdd == 'buy') {
            this.addModulesSubmit();
          } else {
            let buyout = this.form.buy_type == 1;
            let months = buyout ? 1200 : Number(this.form.new_months) * 12;
            let obj = {
              name: this.form.name,
              code: this.form.code,
              key: this.form.key,
              contact_name: this.form.contact_name,
              mobile: this.form.mobile,
              note: this.form.note,
              modules: this.form.modules.join(','),
              std_users: this.form.std_users,
              bi_users: this.form.bi_users,
              months: months,
              pay_type: this.form.pay_type,
              buyout: buyout,
            };
            this.newBuySubmit(obj);
          }
        }
      });
    },

    addModulesSubmit() {
      let newModules = this.form.modules.filter(code => !this.purchasedModuleCodes.includes(code));
      if (newModules.length === 0) {
        this.$message.warning('请至少选择一个新模块');
        return;
      }
      let modules = newModules.join(',');
      FDCLocalAddModulesPrice(this.modifyId, { modules: modules })
        .then((res) => {
          this.$store.dispatch('user/userinfo').then(() => {
            let finance = {
              special: this.$store.getters.userInfo.finance.af_point,
              universal: this.$store.getters.userInfo.finance.point,
            };
            let parms = {
              price: res.total,
              payType: this.form.pay_type,
            };
            let result = payVerify(parms, finance);
            let tableData = [];
            if (res.module_bill && res.module_bill.modules) {
              res.module_bill.modules.forEach((m) => {
                tableData.push({
                  item: "增购模块",
                  name: m.name,
                  days: m.days === "买断" ? "买断" : m.days + "天",
                  price: m.price,
                });
              });
            }
            tableData.push({ item: "合计", name: "", days: "", price: res.total });
            this.payTableData = tableData;
            this.payDescription = result.msg;
            this.payBtnShow = result.success;
            this.payAlertType = result.success ? "success" : "error";
            this.payAction = "addModules";
            this.payActionData = { modules: modules };
            this.payTableShow = true;
          });
        })
        .catch(() => {});
    },

    newBuySubmit(obj) {
      let buyout = this.form.buy_type == 1;
      let priceObj = {
        pay_type: obj.pay_type,
        modules: obj.modules,
        months: obj.months,
        std_users: obj.std_users,
        bi_users: obj.bi_users,
      };
      fdcBuyPriceAuth(priceObj)
        .then((res) => {
          this.$store.dispatch('user/userinfo').then(() => {
            let finance = {
              special: this.$store.getters.userInfo.finance.af_point,
              universal: this.$store.getters.userInfo.finance.point,
            };
            let parms = {
              price: res.total,
              payType: this.form.pay_type,
            };
            let result = payVerify(parms, finance);
            let tableData = [];
            // 模块费用
            if (res.module_bill && res.module_bill.modules) {
              res.module_bill.modules.forEach((m) => {
                tableData.push({
                  item: "模块费用",
                  name: m.name,
                  days: m.days === "买断" ? "买断" : m.days + "天",
                  price: m.price,
                });
              });
            }
            // 用户费用
            if (res.user_bill) {
              let isBuyout = res.module_bill && res.module_bill.modules && res.module_bill.modules.length > 0 && res.module_bill.modules[0].days === "买断";
              if (res.user_bill.bi_users > 0) {
                tableData.push({
                  item: "用户费用",
                  name: "工作用户 x " + res.user_bill.bi_users,
                  days: isBuyout ? "买断" : "",
                  price: res.user_bill.bi_price,
                });
              }
              if (res.user_bill.std_users > 0) {
                tableData.push({
                  item: "用户费用",
                  name: "查看用户 x " + res.user_bill.std_users,
                  days: isBuyout ? "买断" : "",
                  price: res.user_bill.std_price,
                });
              }
            }
            tableData.push({ item: "合计", name: "", days: "", price: res.total });
            this.payTableData = tableData;
            this.payDescription = result.msg;
            this.payBtnShow = result.success;
            this.payAlertType = result.success ? "success" : "error";
            this.payAction = "newBuy";
            this.payActionData = obj;
            this.payTableShow = true;
          });
        })
        .catch(() => {});
    },

    confirmPay() {
      if (this.payAction === "addModules") {
        FDCLocalAddModules(this.modifyId, {
          modules: this.payActionData.modules,
          pay_type: this.form.pay_type,
        }).then(() => {
          this.$message({ type: 'success', message: '增购模块成功!' });
          this.resetForm();
          this.visible = false;
          this.$parent.getAuthData();
        });
      } else if (this.payAction === "newBuy") {
        fdcBuyAuth(this.payActionData).then(() => {
          this.$message({ type: 'success', message: '购买成功!' });
          this.resetForm();
          this.visible = false;
          this.$parent.getAuthData();
        });
      }
    },

    _checkBuyout(dateStr) {
      if (!dateStr) return false;
      try {
        const [datePart] = dateStr.split(" ");
        const [year, month, day] = datePart.split("-").map(Number);
        const targetDate = new Date(year, month - 1, day);
        const cutoffDate = new Date(2099, 11, 31, 23, 59, 59);
        return targetDate > cutoffDate;
      } catch (e) {
        return false;
      }
    },

    cancel() {
      if (this.payTableShow) {
        this.payTableShow = false;
        return;
      }
      if (this.$refs.form) this.$refs.form.clearValidate();
      this.resetForm();
      this.payTableShow = false;
      this.visible = false;
    },

    openSceneDialog() {
      this.$refs.sceneDialog.show();
    },

    applyScene(scene) {
      this.form.modules = scene.modules.slice();
      this.form.bi_users = scene.bi_users;
      this.form.std_users = scene.std_users;
      this.$message.success('已应用「' + scene.name + '」，可根据需要手动调整');
    },
  },
};
</script>

<style scoped>
.scene-quick-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: linear-gradient(135deg, #eef2ff 0%, #e0e9ff 100%);
  border: 1px solid #b8cbff;
  color: #409eff;
  font-size: 12px;
  font-weight: 600;
  padding: 5px 12px;
  border-radius: 16px;
  cursor: pointer;
  transition: all .18s;
  margin-bottom: 8px;
  height: 26px;
}
.scene-quick-btn:hover {
  background: linear-gradient(135deg, #d6e0ff 0%, #c4d4ff 100%);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.18);
}
.module-checkbox-group {
  display: flex;
  flex-wrap: wrap;
}
.module-checkbox-group >>> .el-checkbox {
  width: calc(100% / 3);
  margin-right: 0;
  margin-bottom: 8px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/agileFlow/buyFdc.vue